// This file is auto-generated by @hey-api/openapi-ts
import { client as _heyApiClient } from './client.gen.js';
/**
 * Create a new organization in `pending` with the caller as owner.
 */
export const orgSignup = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/org/signup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
/**
 * Org details plus my membership.
 */
export const getOrgMe = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/org/me',
        ...options
    });
};
/**
 * Invite a member by email. Owner/admin only.
 */
export const inviteMember = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/org/members/invite',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
/**
 * Disable a membership. Owner only.
 */
export const disableMember = (options) => {
    return (options.client ?? _heyApiClient).delete({
        url: '/org/members/{id}',
        ...options
    });
};
/**
 * List warehouses in the current org.
 */
export const listWarehouses = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/org/warehouses',
        ...options
    });
};
/**
 * Create a warehouse.
 */
export const createWarehouse = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/org/warehouses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
/**
 * Edit or archive a warehouse.
 */
export const updateWarehouse = (options) => {
    return (options.client ?? _heyApiClient).patch({
        url: '/org/warehouses/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
/**
 * List stores in the current org.
 */
export const listStores = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/org/stores',
        ...options
    });
};
/**
 * Create a store in `pending`.
 */
export const createStore = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/org/stores',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
/**
 * Edit a store (name, address, default warehouse, links).
 */
export const updateStore = (options) => {
    return (options.client ?? _heyApiClient).patch({
        url: '/org/stores/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
/**
 * Generate a one-time activation code for the store. Plaintext code is
 * returned ONCE in this response and is never retrievable again.
 *
 */
export const generateActivationCode = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/org/stores/{id}/activation',
        ...options
    });
};
/**
 * Revoke a store device credential.
 */
export const revokeStoreDevice = (options) => {
    return (options.client ?? _heyApiClient).delete({
        url: '/org/stores/{id}/devices/{deviceId}',
        ...options
    });
};
